<template>
  <section class="task-wrap" :style="dBHeight">
    <modals-container @updateSpaceSize="getGroupList"></modals-container>
    <div class="tab_ty1">
      <AuditTab :currentTab="1" />
      <div class="tab-content">
        <!-- 이력 Tab -->
        <div>
          <div class="tab_ty2">
            <AuditSubTab :currentTab="1" :currentTab2="0" />
            <div class="tab-content">
              <div>
                <div class="tb-list_ty1 audit001">
                  <div class="tb-header clear">
                    <div class="tb_num fl">
                      <div class="num"  v-html="$i18nUtil.trans('search.000','총 {cnt}건',{cnt:totalCount})"> 
                      </div>
                    </div>
                    <div class="search_ty2 fr">
                      <div class="calendar_box_grp small">
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="startDate"
                            :disabled-dates="startDisabledDate"
                          ></datepicker>
                        </div>
                        <span>~</span>
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="endDate"
                            :disabled-dates="endDisabledDate"
                          ></datepicker>
                        </div>
                      </div>
                      <div class="search_ty2">
                        <input
                          type="text"
                          required
                          :placeholder="$i18nUtil.trans('message.ProAndPrivateList.001','그룹명 검색')"
                          @focus="$event.target.placeholder = ''"
                          @focusout="$event.target.placeholder = $i18nUtil.trans('message.ProAndPrivateList.001','그룹명 검색')"
                          v-model="searchGroupName"
                          @keyup.enter="getGroupList()"
                        />
                        <button
                          type="button"
                          class="input-txt"
                          @click="getGroupList()"
                        >
                          {{$i18nUtil.trans("search.039","검색")}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- //tb-header -->

                  <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="groupList"
                    hide-default-footer
                    class="tb-contents"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>
                          <div>
                            <span
                              class="ell-singleline d-block cursor-pointer"
                              @click="GroupSetting(item)"
                            >
                              {{ item.groupName }}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.groupKbn }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.inoutKbn }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.publicYn }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span
                              >{{ (item.spaceSize / 1024).toFixed(1) }}GB</span
                            >
                          </div>
                        </td>
                        <td>
                          <div>
                            <span
                              >{{
                                (item.currentSpaceSize / 1024 / 1024).toFixed(
                                  1
                                )
                              }}MB</span
                            >
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.fileCount }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.boardCount }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{
                              item.delDate == null
                                ? ""
                                : $moment(item.delDate).format("YYYY.MM.DD")
                            }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{
                              $moment(item.lastGroupUpdDate).format(
                                "YYYY.MM.DD"
                              )
                            }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{
                              item.groupStatus == "01"
                                ? $i18nUtil.trans("message.ProAndPrivateManage.005","운영")
                                : item.groupStatus == "02"
                                ? $i18nUtil.trans("message.ProAndPrivateManage.006","폐쇄")
                                : item.groupStatus == "03"
                                ? $i18nUtil.trans("message.ProAndPrivateManage.007","영구")
                                : $i18nUtil.trans("message.ProAndPrivateList.002","정지")
                            }}</span>
                          </div>
                        </td>

                        <td>
                          <div>
                            <span>{{
                              $moment(item.regDate).format("YYYY.MM.DD")
                            }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.regUserId }}</span>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template slot="no-data">
                      <div class="nodata-txt-noicon">
                        <v-alert :value="true">
                          {{$i18nUtil.trans("entity.project","과제")}} / {{$i18nUtil.trans("message.ProAndPrivateList.003","개인공간이 없습니다.")}}
                        </v-alert>
                      </div>
                    </template>
                  </v-data-table>

                  <div v-show="pageCount > 0" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getGroupList"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";
import ProAndPrivateSetting from "./modal/ProAndPrivateSetting";
export default {
  components: {
    Datepicker,
    AuditSubTab,
    AuditTab,
    ProAndPrivateSetting,
  },
  data() {
    return {
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      enabled: true,
      show: false,
      page: 1,
      pageCount: 1,
      totalCount: 0,
      itemsPerPage: 10,
      singleSelect: false,
      selected: [],
      headers: [
        {
          text: this.$i18nUtil.trans("entity.group.groupName","공간명"),
          value: "groupName",
          align: "center",
          sortable: false,
        },
        { text: this.$i18nUtil.trans("entity.group.groupKbn","공간타입"), value: "groupKbn", sortable: false },
        { text: this.$i18nUtil.trans("entity.group.inoutKbn","내외부구분"), value: "inoutKbn", sortable: false },
        { text: this.$i18nUtil.trans("entity.group.publicYn","공개여부"), value: "publicYn", sortable: false },
        { text: this.$i18nUtil.trans("entity.group.spaceSize","공간용량"), value: "spaceSize", sortable: false },
        { text: this.$i18nUtil.trans("entity.group.currentSpaceSize","현재사용용량"), value: "currentSpaceSize", sortable: false },
        { text: this.$i18nUtil.trans("entity.group.fileCount","파일 개수"), value: "fileCount", sortable: false },
        { text: this.$i18nUtil.trans("entity.group.boardCount","보드 개수"), value: "boardCount", sortable: false },
        { text: this.$i18nUtil.trans("entity.group.delDate","폐쇄일"), value: "delDate", sortable: false },
        { text: this.$i18nUtil.trans("entity.group.lastGroupUpdDate","최근 수정"), value: "lastGroupUpdDate", sortable: false },
        { text: this.$i18nUtil.trans("entity.group.groupStatus","공간상태"), value: "groupStatus", sortable: false },
        { text: this.$i18nUtil.trans("entity.group.regDate","등록일"), value: "regDate", sortable: false },
        { text: this.$i18nUtil.trans("entity.group.regUserId","생성자"), value: "regUserId", sortable: false },
      ],
      groupList: [],
      searchGroupName: "",
      startDate: new Date(this.$moment().subtract(1, "months")),
      endDate: new Date(this.$moment()),
      startDisabledDate: {
        from: new Date(this.$moment()),
      },
      endDisabledDate: {
        to: new Date(this.$moment().subtract(1, "months")),
      },
    };
  },
  created() {
    this.getGroupList();
  },
  watch: {
    startDate() {
      this.page = 1;
      this.getGroupList();
    },
    endDate() {
      this.page = 1;
      this.getGroupList();
    },
  },
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal"]),
    /* 공간 목록 조회 */
    getGroupList() {
      let obj = this;

      let reqData = {};
      reqData.params = {
        currentPage: obj.page.toString(),
        itemsPerPage: obj.itemsPerPage.toString(),
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
        searchGroupName: obj.searchGroupName,
      };
      reqData.url = "/api/cogroup/cogroup/getProAndPrivateCogroupList";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.groupList = res.result.groupList;
            obj.totalCount = res.result.groupCount;
            obj.pageCount = res.result.groupPageCount;
            // obj.totalCount % 10 == 0
            //   ? obj.totalCount / 10
            //   : Math.floor(obj.totalCount / 10 + 1);
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    setDisabledDate() {
      this.startDisabledDate.from = this.endDate;
      this.endDisabledDate.to = this.startDate;
    },
    GroupSetting(item) {
      const modalInfo = {
        obj: this.$modal,
        component: ProAndPrivateSetting,
        width: "1220px",
        height: "665px",
        groupId: item.groupId,
        inoutKbn: item.inoutKbn,
        status: item.groupStatus,
        groupKbn: item.groupKbn,
      };
      this.showModal(modalInfo);
    },
  },
};
</script>

<style scoped>
.audit001 {
  margin-top: 38px;
}
.audit001 >>> td:nth-child(1) > div > .ell-singleline {
  width: 110px;
}
.audit001 >>> th:nth-child(1),
.audit001 >>> td:nth-child(1) {
  padding-left: 25px;
  width: calc(100% - 940px) !important;
  text-align: left;
}
.audit001 >>> th:nth-child(2),
.audit001 >>> td:nth-child(2) {
  width: 60px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(3),
.audit001 >>> td:nth-child(3) {
  width: 70px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(4),
.audit001 >>> td:nth-child(4) {
  width: 50px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(5),
.audit001 >>> td:nth-child(5) {
  width: 80px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(6),
.audit001 >>> td:nth-child(6) {
  width: 100px !important;
  text-align: center;
}

.audit001 >>> th:nth-child(7),
.audit001 >>> td:nth-child(7) {
  width: 50px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(8),
.audit001 >>> td:nth-child(8) {
  width: 50px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(9),
.audit001 >>> td:nth-child(9) {
  width: 100px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(10),
.audit001 >>> td:nth-child(10) {
  width: 100px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(11),
.audit001 >>> td:nth-child(11) {
  width: 70px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(12),
.audit001 >>> td:nth-child(12) {
  width: 100px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(13),
.audit001 >>> td:nth-child(13) {
  width: 200px !important;
  text-align: center;
}
.audit001 >>> th.text-center {
  text-align: center;
}
.audit001 >>> input {
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/ProAndPrivateList.vue